import axios from "axios";
import React, { useState } from "react";
import { useSelector } from "react-redux";

const AvatarUpload = ({ changeInfoUser }) => {
    const [avatar, setAvatar] = useState("");
    const [preview, setPreview] = useState("");


    // const [selectedFile, setSelectedFile] = useState(null);
    const [uploadStatus, setUploadStatus] = useState(null);
    const [showStatus, setShowStatus] = useState(false);
    const [isUploading, setIsUploading] = useState(false);

    const { userAvatar } = useSelector(state => state.user)
    const userAvatarCheck = changeInfoUser.user_avatar;
    const { apiUrl } = useSelector(state => state.api);

    const handleAvatarChange = (event) => {
        const selectedFile = event.target.files[0];
        setAvatar(selectedFile);
        if (selectedFile) {
            const reader = new FileReader();
            reader.onload = () => {
                setPreview(reader.result);
            };

            reader.readAsDataURL(selectedFile);

        } else {
            setPreview("");
        }
    };
    // console.log("Selected file:", avatar);
    const handleSubmit = async (event) => {
        event.preventDefault();
        // console.log("Selected file:", avatar);
        // You can add your own logic here to upload the file to your server or to display the selected image
        try {
            setIsUploading(true); // disable the button
            //old path avatar
            const dataAvatar = changeInfoUser.user_avatar;
            const formData = new FormData();
            formData.append('myFilesAvatar', avatar); // note must be correct "myFiles" with <input type="file" name="myFilesAvatar" onChange={handleFileChange} />
            formData.append('dataAvatar', dataAvatar); // append additional data
            console.log(`${apiUrl}/upload/uploadmultiple/avatar`);
            const response = await axios.post(`${apiUrl}/upload/uploadmultiple/avatar`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    token: localStorage.getItem('token')
                }
            });
            setUploadStatus('File uploaded successfully');

            setShowStatus(true);
            setTimeout(() => {
                // window.location.reload();
                setShowStatus(false);
            }, 2000); // reload after 2 seconds

        } catch (err) {
            console.log(err);
            if (err.response) {
                // The request was made and the server responded with a status code
                setUploadStatus(`${err.response.data.message}`);
            } else if (err.request) {
                // The request was made but no response was received
                setUploadStatus('File upload failed: No response received from the server');
            } else {
                // Something happened in setting up the request that triggered an Error
                setUploadStatus(`File upload failed: ${err.message}`);
            }
            setShowStatus(true);
            setTimeout(() => setShowStatus(false), 3000);
        } finally {
            // enable the button
            setTimeout(() => {
                setIsUploading(false);
            }, 3000); // reload after 2 seconds
        }
    };


    return (
        <>
            <form onSubmit={handleSubmit}>
                {userAvatarCheck && <div className="mb-3">
                    <label htmlFor="avatarInput" className="form-label">
                        Your Avatar
                    </label>
                    <div>
                        <img src={apiUrl + "/" + userAvatar} alt="Avatar" className="img-thumbnail my-3" width="350" height="350" />
                    </div>
                    <div>
                        <img src={apiUrl + "/" + userAvatar} alt="Avatar" class="navbar-brand" width="35" height="35" />
                    </div>
                </div>}

                <div className="mb-3">
                    <label htmlFor="avatarInput" className="form-label">
                        Upload Avatar
                    </label>
                    <input
                        type="file"
                        className="form-control"
                        id="avatarInput"
                        name="myFilesAvatar"
                        accept="image/png, image/jpeg"
                        onChange={handleAvatarChange}
                    />
                    <div className="form-text">Please select a JPG or PNG file.</div>
                </div>
                {preview && (
                    <img src={preview} alt="Preview" className="img-thumbnail my-3" />
                )}
                <button type="submit" className="btn btn-primary" disabled={isUploading}>
                    Upload
                </button>
            </form>
            {showStatus && <p class="uploadStatus">{uploadStatus}</p>}
        </>
    );
};

export default AvatarUpload;
